import React from 'react';
import { Col, Row, Text } from 'components';
import { FontAwesome5 } from '@expo/vector-icons';
import { StyleSheet, ScrollView } from 'react-native';
import IssueCard, { IssueCardData } from './IssueCard';

const MSC_BLUE = '#004B8D';
const ERROR = '#E94A36';
const STEEL_GREY = '#E0E2E5';

interface IssuesPanelProps {
  issues: IssueCardData[];
  onIssueAction?: (issueId: string, action: string) => void;
}

const IssuesPanel: React.FC<IssuesPanelProps> = ({ issues, onIssueAction }) => {
  return (
    <Col style={styles.rightPanel}>
      <Row alignItems="center" marginBottom={24}>
        <Col style={[styles.sectionIcon, { backgroundColor: ERROR }]}>
          <FontAwesome5 name="exclamation-triangle" size={16} color="white" />
        </Col>
        <Text fontSize={20} bold style={{ color: MSC_BLUE, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          ISSUES & CUSTOMER FEEDBACK
        </Text>
      </Row>
      <ScrollView showsVerticalScrollIndicator={false}>
        <Col style={styles.issuesFeed}>
          {issues.map((issue) => (
            <IssueCard key={issue.id} issue={issue} onAction={onIssueAction} />
          ))}
        </Col>
      </ScrollView>
    </Col>
  );
};

const styles = StyleSheet.create({
  rightPanel: {
    flex: 1,
  },
  sectionIcon: {
    width: 32,
    height: 32,
    backgroundColor: MSC_BLUE,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  issuesFeed: {
    // @ts-ignore
    gap: 16,
  },
});

export default IssuesPanel;

